import {Button} from '@wandb/weave/components/Button';
import React, {useCallback} from 'react';

import {trackSetting} from '../../services/analytics/workspaceSettingsEvents';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';

export const WorkspaceSettings = ({isIconOnly}: {isIconOnly?: boolean}) => {
  const {toggleWorkspaceDrawer, contentType} = useWorkspaceDrawerContext();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      toggleWorkspaceDrawer('workspace-settings');
      if (contentType == null) {
        trackSetting({
          action: 'open drawer',
          page: 'workspace',
        });
      }
    },
    [contentType, toggleWorkspaceDrawer]
  );

  if (isIconOnly) {
    return (
      <Button
        aria-label="Workspace settings"
        data-test="workspace-settings-button"
        icon="settings"
        onClick={onClick}
        tooltip="Workspace settings"
        tooltipProps={{
          side: 'bottom',
        }}
        variant="secondary"
      />
    );
  }

  return (
    <Button
      aria-label="Workspace settings"
      data-test="workspace-settings-button"
      icon="settings"
      onClick={onClick}
      tooltip="Workspace settings"
      tooltipProps={{
        side: 'bottom',
      }}
      variant="secondary">
      Settings
    </Button>
  );
};
